// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__zYydW","loadingShrink":"PageLoading_loadingShrink__1KCLN"};